import { render, staticRenderFns } from "./resellerdashboard.vue?vue&type=template&id=aa1e4346&"
import script from "./resellerdashboard.vue?vue&type=script&lang=js&"
export * from "./resellerdashboard.vue?vue&type=script&lang=js&"
import style0 from "./resellerdashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports